import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import Notiflix from "notiflix";

// ANT DESIGN IMPORTS
import {
  Spin,
  Typography,
  Collapse,
  Button,
  Divider,
  Modal,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  InputNumber,
  Input,
} from "antd";
import { EditOutlined, PlusCircleOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
import styles from "../../../../../../assets/styles/styles";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { showCheckerApprovalModal } from "../../../../../../components/CheckerModal";

const EditPersonalInfo = (props) => {
  const {
    currentCustomerObj,
    userData,
    useForm,
    refreshList,
    customerDetails,
    identifactionTypeData,
  } = props;
  const { session } = userData;
  // const [useForm] = Form.useForm();

  const [isLoading, setIsLoading] = useState(false);

  // MODAL VARIABLES
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const showModal = () => {
    setIsModalOpen(true);
  };

  console.log(useForm);

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate]
  );

  const onSubmit = (formValues) => {
    formValues.customerId = currentCustomerObj.id;
    formValues.dateFormat = "dd MMMM yyyy";

    delete formValues.name;

    const url = `${apiConfig.Counterparty}/${currentCustomerObj.id}`;

    const body = {
      ...formValues,
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateCounterPartyMsg);

          // close modal
          setIsModalOpen(false);

          //refresh the list
          refreshList();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.payChargeMsg);
          setIsLoading(false);
        },
      }
    );
  };
  return (
    <>
      {BOM.HasPermission("CREATE_CLIENT_LIMIT") && (
        <Button
          type="primary"
          shape="round"
          className="of-primaryBtnColor"
          style={{
            marginLeft: "auto",
          }}
          onClick={showModal}
        >
          <EditOutlined />
          &nbsp;{labelConfig.edit}
        </Button>
      )}
      <Modal
        title="Edit Counter Party"
        open={isModalOpen}
        okText="Save"
        cancelText="Cancel"
        okButtonProps={{
          autoFocus: true,
          htmlType: "submit",
          style: {
            ...styles.ofPrimaryBtnColor,
          },
        }}
        centered
        // onOk={onSubmit}
        onCancel={handleCancel}
        width={800}
        modalRender={(dom) => (
          <Form
            layout="vertical"
            form={useForm}
            initialValues={{
              unAuthorisedLimit: 0,
              utilizedLimit: 0,
              unUsedLimit: 0,
              digitsAfterDecimal: 2,
              inMultiplesOf: 100,
            }}
            onFinish={onSubmit}
          >
            {dom}
          </Form>
        )}
        style={{
          height: 600,
          overflow: "auto",
        }}
      >
        <Spin spinning={isLoading} tip="Saving..." size="large">
          <Row>
            <Divider orientation="left">Contact Information</Divider>

            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.fullName}
                name="name"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.fullName),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.fullName)}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.creditRiskRating}
                name="creditRiskRating"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.creditRiskRating),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.creditRiskRating
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactEmail}
                name="contactEmail"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.contactEmail),
                  },
                  {
                    type: "email",
                    message: "Please enter a valid email address",
                  },
                  {
                    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Please enter a valid email format",
                  },
                  {
                    max: 254,
                    message: "Email address cannot exceed 254 characters",
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactEmail
                  )}
                  maxLength={128}
                  type="email"
                />
              </Form.Item>
            </Col>
            {/* Contact Phone No - International format */}
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactPhoneNo}
                name="contactPhoneNo"
                rules={[
                  {
                    pattern: /^\+?[1-9]\d{1,14}$/,
                    message:
                      "Please enter a valid phone number (e.g., +1234567890)",
                  },
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.contactPhoneNo),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactPhoneNo
                  )}
                  maxLength={16}
                  onChange={(e) => {
                    // Allow only numbers, plus sign at the beginning, and spaces/hyphens for formatting
                    e.target.value = e.target.value.replace(/[^+\d\s-]/g, "");
                  }}
                />
              </Form.Item>
            </Col>
            {/* <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactEmail}
                name="email"
                rules={[
                  {
                    required: true,
                    message: BOM.CheckReqFld(labelConfig.contactEmail),
                  },
                ]}
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactEmail
                  )}
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={labelConfig.contactPhoneNo}
                name="contactPhoneNo"
              >
                <Input
                  placeholder={BOM.handlePlaceholderMsg(
                    labelConfig.contactPhoneNo
                  )}
                />
              </Form.Item>
            </Col> */}
          </Row>
        </Spin>
      </Modal>
    </>
  );
};

export default EditPersonalInfo;
